import React, { useEffect,useState } from "react";
import { v4 as uuidv4 } from 'uuid';
function Etape3({ formData, handleChange, setFormData,user,isReadOnly,page,renderError }) {

  const [commentaire, setCommentaire] = useState("");

  const addCommentaire = () => {
    if (!commentaire.trim()) {
      alert('Le commentaire ne peut pas être vide.');
      return;
    }
    const now = new Date();
      const dateHeure = now.toLocaleString("fr-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      });
    const newCommentaire = {
      commentaireUsers: commentaire,
      nom: user.displayName,
      userId: user.id,
      courriel: user.mail,
      dateHeure,
      id: uuidv4(),  // Unique ID for this comment
      ancien: false
    };

    // Add the new comment to the listeDesNotes array
    setFormData(prevData => ({
      ...prevData,
      listeDesNotes: [...prevData.listeDesNotes, newCommentaire]
    }));

    setCommentaire("");  // Clear the input field after adding
  };

  const deleteCommentaire = (id) => {
    // Remove the comment with the specified ID from the listeDesNotes array
    setFormData(prevData => ({
      ...prevData,
      listeDesNotes: prevData.listeDesNotes.filter(note => note.id !== id)
    }));
  };


  // Recalculer 'montantkilometrage' quand 'depenses' change
  useEffect(() => {
    const newMontantKilometrage = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Kilométrage")
      .reduce((total, row) => total + (Number(row.montant) || 0), 0);

    

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantkilometrage: parseFloat(newMontantKilometrage.toFixed(2)),
    }));
  }, [formData.depenses, setFormData]);


  // Recalculer 'montantVisaConseil' quand 'depenses' change
  useEffect(() => {
    const newMontantVisaConseil = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Visa du Conseil")
      .reduce((total, row) => total + (Number(row.montant) || 0), 0);

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantVisaConseil: parseFloat(newMontantVisaConseil.toFixed(2)),
    }));
  }, [formData.depenses, setFormData]);

  // Recalculer 'montantAutresDepenses' quand 'depenses' change
  useEffect(() => {
    const newMontantAutresDepenses = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Autre dépense")
      .reduce((total, row) => total + (Number(row.montant) || 0), 0);

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantAutresDepenses: parseFloat(newMontantAutresDepenses.toFixed(2)),
    }));
  }, [formData.depenses, setFormData]);

  // Recalculer 'montantRembourserConseil' quand 'depenses' change
  useEffect(() => {
    const newMontantRembourserConseil = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Visa du Conseil")
      .reduce((total, row) => total + (Number(row.montantRembourser) || 0), 0);

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantRembourserConseil: parseFloat(
        newMontantRembourserConseil.toFixed(2)
      ),
    }));
  }, [formData.depenses, setFormData]);

  // Recalculer 'montantNet' quand les autres montants changent
  useEffect(() => {
    const kilometrage = parseFloat(formData.montantkilometrage) || 0;
  const autresDepenses = parseFloat(formData.montantAutresDepenses) || 0;
  const rembourserConseil = parseFloat(formData.montantRembourserConseil) || 0;

  const newMontantNet = kilometrage + autresDepenses - rembourserConseil;

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantNet: parseFloat(newMontantNet.toFixed(2)),
    }));
    // console.log("formData.montantkilometrage : " ,newMontantNet)
    // console.log("formData.montantAutresDepenses : " ,newMontantNet)
    // console.log("formData.montantRembourserConseil : " ,newMontantNet)
    // console.log("formData.newMontantNet : " ,newMontantNet)
  }, [
    formData.montantkilometrage,
    formData.montantAutresDepenses,
    formData.montantRembourserConseil,
    setFormData,
  ]);

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      {/* <h1 className="text-2xl font-bold mb-6 text-black">
          Information générale
        </h1> */}
      <div className="mb-3 flex w-full justify-end">
        <div className="w-full max-w-sm">
          <label
            htmlFor="numeroFormulaire"
            className="block text-sm font-medium text-slate-700"
          >
            Numéro de formulaire:
          </label>
          <input
            type="text"
            id="numeroFormulaire"
            name="numeroFormulaire"
            value={formData.numeroFormulaire}
            onChange={handleChange}
            required
            disabled
            className="mt-1.5 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-[15px] text-slate-700 shadow-sm"            />
          
        </div>
      </div>

      <div className="mb-3 flex w-full justify-end">
        <div className="w-full max-w-sm">
          <label
            htmlFor="dateEntreeEnVigueur"
            className="block text-sm font-medium text-slate-700"
          >
            Date :
          </label>
          <input
            type="date"
            id="dateSoumission"
            name="dateSoumission"
            value={formData.dateSoumission?.split("T")[0] ?? ""}
            onChange={handleChange}
            required
            disabled
            className="mt-1.5 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-[15px] text-slate-700 shadow-sm"            />
          
        </div>
      </div>

      <div className="my-6 flex w-full justify-center">
  <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
    <p className="text-md font-bold flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
        />
      </svg>
      Réclamation mensuelle de dépenses d'emploi
    </p>
  </div>
</div>

      <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-pink-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 17v-6h6v6m2 4H7a2 2 0 01-2-2V7a2 2 0 012-2h5l2 2h5a2 2 0 012 2v12a2 2 0 01-2 2z"
      />
    </svg>
    Sommaire des dépenses réclamées
  </p>
</div>

      <div className="mt-5 w-full rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
        <div className="border-b border-slate-100 pb-4">
          <h3 className="text-sm font-semibold text-slate-900">Détail des montants</h3>
          <p className="mt-1 text-sm text-slate-600">
            Montants calculés automatiquement à partir des dépenses saisies.
          </p>
        </div>
        <div className="mt-4 grid w-full grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-[minmax(0,28rem)_minmax(0,28rem)]">
        <div className="w-full min-w-0">
          <label
            htmlFor="montantkilometrage"
            className="block text-sm font-medium text-slate-700"
          >
            Montant du kilométrage :
          </label>
          <div className="relative">
  <input
    type="text"
    // step="0.01"
    id="montantkilometrage"
    name="montantkilometrage"
    value={
      formData.montantkilometrage !== null &&
      formData.montantkilometrage !== undefined
        ? parseFloat(formData.montantkilometrage).toFixed(2)
        : ""
    }
    readOnly
    className="mt-1.5 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 pr-9 text-[15px] text-slate-700 shadow-sm"
  />
  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
</div>

        </div>

        <div className="w-full min-w-0">
          <label
            htmlFor="montantVisaConseil"
            className="block text-sm font-medium text-slate-700"
          >
            Montant des dépenses Visa du Conseil :
          </label>
          <div className="relative">
  <input
    type="text"
    // step="0.01"
   id="montantVisaConseil"
            name="montantVisaConseil"
    value={
      formData.montantVisaConseil !== null &&
      formData.montantVisaConseil !== undefined
        ? parseFloat(formData.montantVisaConseil).toFixed(2)
        : ""
    }
    readOnly
    className="mt-1.5 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 pr-9 text-[15px] text-slate-700 shadow-sm"
  />
  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
</div>
          
        </div>
        <div className="w-full min-w-0">
          <label
            htmlFor="montantAutresDepenses"
            className="block text-sm font-medium text-slate-700"
          >
            Montant des autres dépenses :
          </label>
          <div className="relative">
  <input
    type="text"
    // step="0.01"
    id="montantAutresDepenses"
    name="montantAutresDepenses"
    value={
      formData.montantAutresDepenses !== null &&
      formData.montantAutresDepenses !== undefined
        ? parseFloat(formData.montantAutresDepenses).toFixed(2)
        : ""
    }
    readOnly
    className="mt-1.5 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 pr-9 text-[15px] text-slate-700 shadow-sm"
  />
  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
</div>
        </div>
               <div className="w-full min-w-0 md:col-start-1">
          <label
            htmlFor="montantRembourserConseil"
            className="block text-sm font-medium text-slate-700"
          >
            Montant à rembourser au Conseil :
          </label>
          <div className="relative">
  <input
    type="text"
    // step="0.01"
    id="montantRembourserConseil"
    name="montantRembourserConseil"
    value={
      formData.montantRembourserConseil !== null &&
      formData.montantRembourserConseil !== undefined
        ? parseFloat(formData.montantRembourserConseil).toFixed(2)
        : ""
    }
    readOnly
    className="mt-1.5 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 pr-9 text-[15px] text-slate-700 shadow-sm"
  />
  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
</div>
        </div>
        <div className="mt-1 w-full min-w-0 border-t border-slate-200 pt-4 md:col-start-1">
          <label
            htmlFor="montantNet"
            className="block text-sm font-medium text-slate-700"
          >
            Montant net :
          </label>
          <div className="relative">
  <input
    type="text"
    // step="0.01"
    id="montantNet"
    name="montantNet"
    value={
      formData.montantNet !== null &&
      formData.montantNet !== undefined
        ? parseFloat(formData.montantNet).toFixed(2)
        : ""
    }
    readOnly
    className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 pr-9 text-[15px] font-semibold text-slate-900 shadow-sm"
  />
  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
</div>
        </div>
        </div>
      </div>

      <section aria-labelledby="commentaires-title" className="mt-8 w-full min-w-0 rounded-xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-100 px-4 py-4 sm:px-5">
          <h3 id="commentaires-title" className="text-base font-semibold text-slate-900">Commentaires</h3>
          <p className="mt-1 text-xs text-slate-500">Ajoutez une précision et consultez les notes associées à cette demande.</p>
        </div>
        <div className="p-4 sm:p-5">
        <div className="w-full max-w-3xl">
          <label
            htmlFor="commentaire"
            className="block text-sm font-medium text-slate-700"
          >
            Nouveau commentaire
          </label>

          <textarea
            placeholder="Ajoutez un commentaire..."
    className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            rows="3"
            id="commentaire"
            name="commentaire"
            value={commentaire}
            maxLength={350}
            onChange={(e) => setCommentaire(e.target.value)}  // Fixing the onChange handler
            readOnly={isReadOnly && page !== "Mes taches"}
          />
          {renderError("commentaireTable")}
      {(isReadOnly===false || (page==="Mes taches" && formData.etatDemande!=="Rejeté")) &&( 
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs text-slate-500">Cliquez sur Ajouter pour inclure votre note dans l’historique.</p>
        <button
        type="button"
        className="inline-flex h-10 items-center justify-center rounded-lg bg-[#24364f] px-4 text-sm font-semibold text-white shadow-sm transition hover:bg-[#17263b] focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2"
        onClick={addCommentaire}
      >
        + Ajouter un commentaire
      </button></div>)}
        </div>
        </div>

      {/* Table to display the list of users with comments */}
      <div className="w-full min-w-0 border-t border-slate-200 p-4 sm:p-5">
  <h4 className="mb-3 text-sm font-semibold text-slate-800">Historique des commentaires <span className="ml-2 font-normal text-slate-500">({formData.listeDesNotes.length})</span></h4>

  <div className="w-full max-w-6xl overflow-x-auto rounded-lg border border-slate-200">
    <table className="w-full min-w-[640px] table-fixed divide-y divide-slate-200 bg-white">
      <thead className="bg-slate-50">
        <tr>
          <th scope="col" className="w-1/4 p-3 text-left text-sm font-semibold text-slate-700">Auteur</th>
          <th scope="col" className="w-2/5 p-3 text-left text-sm font-semibold text-slate-700">Commentaire</th>
          <th scope="col" className="w-1/5 p-3 text-left text-sm font-semibold text-slate-700">Date et heure</th>
          <th scope="col" className="p-3 text-right text-sm font-semibold text-slate-700">Action</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {formData.listeDesNotes.map((note) => (
          <tr
            key={note.id}
            className="hover:bg-gray-50 transition-colors duration-150"
          >
            <td className="break-words p-3 align-top"><span className="block text-[15px] font-medium text-slate-800">{note.nom}</span><span className="mt-1 block break-all text-xs text-slate-500">{note.courriel}</span></td>
            <td className="whitespace-pre-wrap break-words p-3 align-top text-[15px] leading-6 text-slate-700">{note.commentaireUsers}</td>
            <td className="break-words p-3 align-top text-sm text-slate-500">{note.dateHeure}</td>
            <td className="p-3 text-right align-top">
              {!note.ancien && (
                <button
                  type="button"
                  className="inline-flex min-h-9 items-center justify-center rounded-lg border border-red-200 bg-white px-2 text-xs font-medium text-red-700 transition hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-100"
                  onClick={() => deleteCommentaire(note.id)}
                >
                  Supprimer
                </button>
              )}
            </td>
          </tr>
        ))}
        {formData.listeDesNotes.length === 0 && (
          <tr><td colSpan={4} className="px-4 py-8 text-center text-sm text-slate-500">Aucun commentaire ajouté à cette demande.</td></tr>
        )}
      </tbody>
    </table>
  </div>
</div>
      </section>

    </div>
  );
}

export default Etape3;

/* <div className="field">
        <label>Commentaires supplémentaires (facultatif)</label>
        <textarea
          name="commentaireSupplementaire"
          placeholder="Ajouter un commentaire"
          value={formData.commentaireSupplementaire}
          onChange={handleChange}
        />
      </div> */
/* Bouton de soumission ici
      <button onClick={onSubmit}>Soumettre</button> */
